import * as XLSX from 'xlsx';

export type ExcelColumn<RowT> = {
  header: string;
  value: (row: RowT) => any;
};

function normalizeSheetName(name: string): string {
  // Excel limitations: max 31 chars, cannot contain: \ / ? * [ ]
  const cleaned = name.replace(/[\\/?*[\]]/g, '-').trim();
  return (cleaned.length > 0 ? cleaned : 'Dati').slice(0, 31);
}

function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function buildWorksheetFromRows<RowT>(rows: RowT[], columns: ExcelColumn<RowT>[]) {
  const headerRow = columns.map(c => c.header);
  const dataRows = rows.map(row => columns.map(c => c.value(row)));
  const aoa = [headerRow, ...dataRows];
  return XLSX.utils.aoa_to_sheet(aoa);
}

export function exportWorkbookToXlsx(
  fileName: string,
  sheets: Array<{ name: string; worksheet: any }>
) {
  const workbook = XLSX.utils.book_new();

  sheets.forEach(s => {
    XLSX.utils.book_append_sheet(workbook, s.worksheet, normalizeSheetName(s.name));
  });

  const arrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([arrayBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  downloadBlob(blob, fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`);
}
